import React,{useState,useEffect,useRef} from 'react'
import { makePostForFile } from '../../utils/fetchUtils';
import { REQUEST_ACCESS } from '../../utils/constants';

const RequestAccessForm =()=> {

    const fileInputRef =useRef<HTMLInputElement>(null);

    const [userName , setUserName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email,setEmail] = useState('');
    const [disabilityType , setDisabilityType] = useState('');
    const [disabilityCertificate ,setDisabilityCertificate] = useState<File | null>(null)
    const [message,setMessage] = useState('');
    const [displayStatus  , setDisplayStatus] = useState<'form'|'msg'>('form');

    useEffect(()=>{
        document.title = 'Access Request Form - Nclude Portal';
    },[])

    const disabilityTypes = [
        "Blindness",
        "Low-vision",
        "Leprosy Cured persons",
        "Hearing Impairment",
        "Locomotor Disability",
        "Dwarfism",
        "Intellectual Disability",
        "Mental Illness",
        "Autism Spectrum Disorder",
        "Cerebral Palsy",
        "Muscular Dystrophy",
        "Chronic Neurological conditions",
        "Specific Learning Disabilities",
        "Multiple Sclerosis",
        "Speech and Language disability",
        "Thalassemia",
        "Hemophilia",
        "Sickle cell disease",
        "Multiple Disabilities including deaf-blindness",
        "Acid Attack victims",
        "Parkinson’s disease"
    ];

    const handleFileChange = (event: any)=>{
          setDisabilityCertificate(event.target.files[0]);
    }  

    const handleButtonClick = (event: { preventDefault: () => void; })=>{
        event.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click();
        } else {
            console.error("fileInputRef is null.");
        }
    }

    const handleSubmit = async (event:any)=>{
        event.preventDefault();
        if(userName==="" || phoneNumber==="" || disabilityType==="" || email==="" || disabilityCertificate===null){
            setMessage("Please Fill the Required Information");
            return ;
        }

        const formData = new FormData();
        formData.append('file',disabilityCertificate);
        formData.append('userName',userName);
        formData.append('phoneNumber',phoneNumber);
        formData.append('email',email);
        formData.append('disabilityType',disabilityType);
        
        const response = await makePostForFile(REQUEST_ACCESS,formData);
        setDisplayStatus("msg");
        // console.log(response);
    }

  return (
    <div className='flex flex-col items-center'>
       {
        displayStatus==="form" &&
        <> 
            <form onSubmit={handleSubmit}>
            <div className='flex flex-col '>
                <label htmlFor="name" className='mt-12'>
                    Enter Name*
                </label>
                <input
                    className='text-black w-[18.75rem] h-[2.18rem] rounded text-black'
                    id='name'
                    type='text' 
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                />
                <label htmlFor="phonenumber" className='mt-12'>
                    Enter Phone Number*
                </label>
                <input
                    className='text-black w-[18.75rem] h-[2.18rem] rounded'
                    id='phonenumber'
                    type='tel' // Use 'tel' for better semantic and mobile keyboards
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                />
                
                <label htmlFor="email" className='mt-12'>
                    Enter Email*
                </label>
                <input
                    className='text-black w-[18.75rem] h-[2.18rem] rounded'
                    id='email'
                    type='email' 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <select className='text-black w-[18.75rem] mt-12' value={disabilityType} onChange={(e)=>setDisabilityType(e.target.value)}>
                    <option value="">Select Disability Type*</option>
                    {disabilityTypes.map((type, index) => (
                    <option key={index} value={type}>{type}</option>
                    ))}
                </select>

                <div className="">
                        <button className="btn py-6 text-black dark:text-white " aria-label="Attach Your disability certificate here" onClick={handleButtonClick}>
                            <div className="flex flex-row ">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z" fill="currentColor"></path>
                                </svg>
                                <p className="text-white ">Attach Your disability certificate</p>
                            </div>
                        </button>
                        <input  
                                ref={fileInputRef}
                                accept='.pdf'
                                type="file"
                                tabIndex={-1}
                                className="hidden"
                                style={{ display: 'none' }} 
                                onChange={handleFileChange}
                        />
                </div>
                <div className='flex flex-col  justify-center  w-[18.75rem]'>
                        <p className=''>{disabilityCertificate?disabilityCertificate.name:''}</p>
                </div>

                <button type="submit" className="mt-12 bg-[#A643FE] w-[18.75rem] h-[2.5rem] rounded">
                    Submit
                </button>

            </div>
            </form>
            <p>{message}</p>
         </>
       }
       {
         displayStatus==="msg" &&
           <div className='pt-12'>
             <p className='text-xl'>We have sent your Information to the Admin , We will notify you once your request is proccessed</p>
           </div>
       }
        
    </div>
  )
}

export default RequestAccessForm